<script>
import api from '@/api'
import pagination from '@/components/pagination.vue'

export default {
  data() {
    return {
      loading: true,
      pagetitle: 'Audit Logs',
      activityLogs: [],
      totalItems: 0,
      totalPages: 1,
      currentPage: 0,
      perPage: 50,
      baseUrl: `${window.apiUrl}/audit-logs/view`,
    }
  },
  components: {
    pagination,
  },
  async mounted() {
    await this.getActivityLogs()
  },
  methods: {
    async getActivityLogs() {
      const params = {
        page: this.currentPage,
        size: this.perPage,
      }
      await api
        .get(this.baseUrl, { params })
        .then((response) => {
          this.activityLogs = response.data?.auditlogs || []
          this.totalItems = response.data.totalItems
          this.totalPages = response.data.totalPages
          this.currentPage = response.data.currentPage
        })
        .finally(() => {
          this.loading = false
        })
    },

    updatePage(newPage) {
      this.loading = true
      this.currentPage = newPage - 1
      this.getActivityLogs()
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row g-3 align-items-center">
            <div class="col-lg-4 col-md-6">
              <!-- <div class="input-group">
                <input type="search" class="form-control" placeholder="Search here" />
                <span class="input-group-text cursor-pointer">
                  <i class="bx bx-search"></i>
                </span>
              </div> -->
            </div>
          </div>
          <!-- end row -->
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Time</th>
                      <th>Activity</th>
                      <th>IP Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n">
                        <td v-for="m in 4" :key="m" class="placeholder-glow">
                          <span class="placeholder col-12"></span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="activityLogs.length">
                      <tr v-for="(activityLog, activityLogIndex) in activityLogs" :key="activityLogIndex">
                        <td>{{ activityLog.username }}</td>
                        <td>{{ activityLog.actionTime }}</td>
                        <td>{{ activityLog.action }}</td>
                        <td>{{ activityLog.ipAddress }}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="6" class="text-center">No logs found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div v-if="!loading && activityLogs.length" class="card-footer">
          <pagination :baseUrl="baseUrl" :totalItems="totalItems" :perPage="perPage" :currentPage="currentPage + 1" @page-changed="updatePage" />
        </div>
      </div>
    </div>
  </div>
</template>
